import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-discountbanner',

  templateUrl: './discountbanner.component.html',
  styleUrl: './discountbanner.component.scss'
})
export class DiscountbannerComponent implements OnInit {
  private startDate: Date = new Date(environment.bannerStartDate);
  private endDate: Date = new Date(environment.bannerEndDate);

  showBanner: boolean = environment.bannerEnabled && this.isWithinActivePeriod();
  countdown: string = '';
  bannerMessage: string = environment.BANNER_DISCOUNT_MESSAGE;



  ngOnInit() {

    // Verifica si el banner debe estar encendido según la configuración de entorno y las fechas
    if (environment.bannerEnabled && this.isWithinActivePeriod()) {

      this.showBanner = true;
      this.updateCountdown();

      // Actualiza el contador cada segundo
      setInterval(() => this.updateCountdown(), 1000);
    }
  }

  private isWithinActivePeriod(): boolean {
    const now = new Date();
    return now >= this.startDate && now <= this.endDate;
  }

  private updateCountdown() {
    const now = new Date();
    const timeLeft = this.endDate.getTime() - now.getTime();

    if (timeLeft <= 0) {
      this.showBanner = false;
      this.countdown = '';
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

    const pad = (n: number) => String(n).padStart(2, '0');
    this.countdown = `${pad(days)} DÍAS : ${pad(hours)} HRS : ${pad(minutes)} MINS`;
  }



}
